import * as React from "react"
import type { SVGProps } from "react"
const SvgBook = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 20.12q-.27 0-.54-.07a2 2 0 0 1-.49-.2 9 9 0 0 0-2.15-.95 8 8 0 0 0-2.32-.33q-1.05 0-2.06.28a9 9 0 0 0-1.94.77 1 1 0 0 1-1.01-.02 1 1 0 0 1-.49-.88V6.67q0-.28.14-.52a1 1 0 0 1 .41-.38 10.5 10.5 0 0 1 4.95-1.2 11 11 0 0 1 5.5 1.5v12.1a10 10 0 0 1 2.68-1.2 10 10 0 0 1 4.58-.25q.87.15 1.74.45v-12l.74.26q.36.14.71.34.27.12.41.38.15.25.14.52v12.05a1 1 0 0 1-.49.88q-.48.3-1.01.02a9 9 0 0 0-1.94-.77 8 8 0 0 0-2.06-.28q-1.2 0-2.33.33a9 9 0 0 0-2.14.95 2 2 0 0 1-1.03.27m2.83-5.3q-.26.23-.54.09a.5.5 0 0 1-.29-.46V6.27a.5.5 0 0 1 .15-.35l4-4q.25-.24.55-.12t.3.47v8.58a.4.4 0 0 1-.05.2l-.12.17zM10 17.2V7.3a9 9 0 0 0-1.71-.54 9 9 0 0 0-1.79-.19 9 9 0 0 0-1.8.18 9 9 0 0 0-1.7.52v9.93a10 10 0 0 1 3.5-.63 10 10 0 0 1 3.5.63" />
  </svg>
)
export default SvgBook
